import { httpApi } from '@app/api/http.api';

export const getUsuarioByID = (id_usuario: string): Promise<any> =>
  httpApi.get<any>(`/usuario/getUsuarioByID/${id_usuario}`).then(({ data }) => data);

export const actualizarDatosContacto = (data: any): Promise<any> =>
  httpApi.post<any>(`/usuario/actualizarDatosContacto`, { ...data }).then(({ data }) => data);
